// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* .specialistAssignBlock {\n  max-width: 1002px;\n} */\n\n.specialistAssignBlock .workflowManagerWidget {\n  margin-top: -20px;\n  margin-bottom: 10px;\n}\n\n.specialistAssignBlock .workflowManagerWidget .cvsDropDown {\n  width: 30%;\n  float: left;\n  margin-right: 1%;\n}\n\n.specialistAssignBlock .workflowManagerWidget .assignButton {\n  margin: 0 !important;\n  height: 36px;\n  width: 7%;\n  float: left;\n}\n", ""]);
// Exports
module.exports = exports;
